// extracted by mini-css-extract-plugin
export default {"testimonialsSection":"Testimonials_testimonialsSection__jaKsd","testimonialsGrid":"Testimonials_testimonialsGrid__TDt42","testimonialCard":"Testimonials_testimonialCard__ZlegY"};